import { ResponseMeta, ResponseWarningQueries } from "../types/response";

import ApiService from "./ApiService";

export interface AnalysisQueryParams {
  "filter[propertyId]"?: string;
  "filter[property_areas][]"?: string[];
  "filter[monitor_types][]"?: string[];
  appointment_types?: string[];
  from?: string;
  end?: string;
}

export type AnalysisResponse = { data: any } & ResponseMeta &
  ResponseWarningQueries;

const AnalysisService = {
  GetAnalysis: async (
    type: string,
    params: AnalysisQueryParams
  ): Promise<AnalysisResponse> => {
    return ApiService.Get(`analysis/${type}`, { ...params });
  },

  GetPestAnalysis: async (
    propertyId: AnalysisQueryParams
  ): Promise<AnalysisResponse> => {
    return ApiService.Get(`analysis/infestation/monthly`, { ...propertyId });
  },

  GetMonitorSummary: async (
    params: AnalysisQueryParams
  ): Promise<AnalysisResponse> => {
    return ApiService.Get(`analysis/monitor/summary`, { ...params });
  },

  GetMonitorTable: async (
    params: AnalysisQueryParams
  ): Promise<AnalysisResponse> => {
    return ApiService.Get(`analysis/monitor/table`, { ...params }); },
};

export default AnalysisService;
